export default class SortColumnRequest  {
	SortByQueueName?: boolean = false;
	SortByTaskId?: boolean = false;
	SortByStatusName?: boolean = false;
	SortByTaskName?: boolean = false;
	SortByDifficultyName?: boolean = false;
	SortByPriorityName?: boolean = false;
	SortByEstimateTime?: boolean = false;
	SortByWorkTime?: boolean = false;
	constructor(obj?: Partial<SortColumnRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
